import { gql } from '@apollo/client'
import React from 'react'

import { placesClient } from '../../../../utils/apollo/api'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

/**
 * Carrega os Ativos (Cargo) e seus Campos Adicionais — usado para a "Descrição do
 * Cargo" (Campo Adicional do Ativo ID 6, seção 6 - Descrição das Atividades).
 * Mesmo padrão usado por manserv/comercial/segurpro (ver
 * manserv/_load/AssetsFieldValuesLoader.js): o Ativo é resolvido por nome, casando
 * com o texto da resposta da pergunta de Cargo correspondente.
 */
const Context = React.createContext([])
const { Provider } = Context
export const useAssetsFieldValuesState = () => React.useContext(Context)
export const useAssetsFieldValues = () => useAssetsFieldValuesState()?.assets || []

const QUERY = gql`
  query Asset {
    assets(limit: 99999999) {
      id
      name
      type {
        id
        name
      }
      fieldValues {
        id
        value
        field {
          id
          name
        }
      }
    }
  }
`

const AssetsFieldValuesLoader = ({ children }) => {
  const { data, ...state } = useQuery(QUERY, {
    client: placesClient
  })

  return (
    <StatePresenter {...state} noEmptyMessage>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default AssetsFieldValuesLoader
